import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { resetJourney } from '@/store/reset';

export interface DirectPaymentState {
  client?: string,
}

const initialState: Readonly<DirectPaymentState> = {};

export const directPaymentSlice = createSlice({
  name: 'directPayment',
  initialState,
  reducers: {
    setClient(state: DirectPaymentState, action: PayloadAction<string>) {
      return {
        ...state,
        client: action.payload,
      };
    },
  },
  extraReducers: builder => builder.addCase(resetJourney, () => initialState),
});

export const {
  setClient,
} = directPaymentSlice.actions;
